import React, { useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Icon } from '@iq/react-components';
import { useSelector } from 'react-redux';

import AppContext from '../../AppContext';
import UploadStatus from '../UploadStatus';
import FileUploadStatus from '../FileUploadStatus';
import { getIsContributorOrAdmin } from '../../bundles/auth';
import { getActiveSite } from '../../bundles/sites';

const Sidebar = ({ site: { id }, pages = [], headerHeight }) => {
  const site = useSelector(getActiveSite);
  const isContributorOrAdmin = useSelector((state) => getIsContributorOrAdmin(state, site));

  const { theme, isTouchDevice } = useContext(AppContext);
  const [canSidebarExpand, setCanSidebarExpand] = useState(true);
  const expandSideBar = (expand) => (isTouchDevice ? setCanSidebarExpand(expand) : null);
  return (
    <>
      <section
        onMouseOver={() => expandSideBar(true)}
        style={{ top: `${headerHeight}px` }}
        className={`sidebar-component theme-${theme} ${canSidebarExpand ? '' : 'collapse'}`}
      >
        <nav className="main-nav">
          <ul className="pages">
            {pages.map(({ path, title, icon = 'he-report', isPublic }, i) => {
              if (isContributorOrAdmin || isPublic) {
                return (
                  <li key={`${path}-${i}`}>
                    <NavLink
                      exact
                      to={{
                        pathname: `/sites/${id}/${path}/`,
                        search: `page=${i}`,
                      }}
                      onClick={() => expandSideBar(false)}
                      className={isPublic ? 'isPublic' : 'isPrivate'}
                    >
                      <Icon
                        icon={icon}
                        size="m"
                      />
                      <span>{title}</span>
                    </NavLink>
                  </li>
                );
              }
              return null;
            })}
          </ul>
        </nav>
      </section>
      <UploadStatus />
      <FileUploadStatus />
    </>
  );
};

export default Sidebar;
